export default Object.freeze({
    NODE: 'Node',
    IOPS: 'IOPS',
    SCALE_FABRIC: 'Infrastructure',
    STORAGE: 'Storage',
    THROUGHPUT: 'Throughput',
    NETWORK: 'Network',
})
